var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "w3-business-detail" } },
    [
      _c("AppBreadCrumb", {
        staticClass: "visitor-detail-bread-crumb",
        attrs: {
          paths: [{ title: _vm.$t("whatsappV3.channelDetails") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _vm.channel
        ? _c(
            "div",
            { staticClass: "route-page-content breadcrumb-content" },
            [
              _c("SidebarChild", {
                attrs: {
                  items: _vm.menuItems,
                  "selected-item": _vm.currentTab,
                  focusActive: true,
                },
                on: {
                  selected: function (i) {
                    return (_vm.currentTab = i.key)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "page-content-wrapper" }, [
                _c("div", { staticClass: "toolbar" }, [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c(
                        "IconButton",
                        {
                          attrs: {
                            "on-click": function () {
                              return _vm.$router.push(
                                "/integrations/whatsapp-v3"
                              )
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" chevron_left "),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "icon-container" },
                        [_c("WhatsappV3")],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [
                        _vm._v(
                          _vm._s(_vm.$t("whatsappV3.channelLabelPrefix")) +
                            ": " +
                            _vm._s(_vm.channel.name)
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            ghost: "",
                            loading: _vm.resetLoading,
                          },
                          on: { click: _vm.handleResetChannel },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.channel &&
                                  _vm.channel.payload &&
                                  _vm.channel.payload.id
                                  ? _vm.$t("whatsappV3.reinstall")
                                  : _vm.$t("whatsappV3.scanQr")
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.currentTab === "detail"
                  ? _c(
                      "div",
                      [
                        _c("UpdateDetail", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "visibility"
                  ? _c(
                      "div",
                      [
                        _c("Visibility", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "comparison"
                  ? _c(
                      "div",
                      { staticStyle: { padding: "20px" } },
                      [_c("WhatsappComparison")],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "developer"
                  ? _c(
                      "div",
                      [
                        _c("DeveloperSettings", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            icon: "exclamation-circle",
            title: _vm.$t("whatsappV3.deleteChannelTitle"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteCurrentChannel },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("whatsappV3.deleteChannelConfirm")))])]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.resetConfirmModal,
            icon: "exclamation-circle",
            title: _vm.$t("whatsappV3.resetConfirmTitle"),
          },
          on: {
            cancel: function ($event) {
              _vm.resetConfirmModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.resetConfirmModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "primary", loading: _vm.resetLoading },
                      on: { click: _vm.confirmResetChannel },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("whatsappV3.confirmReset")) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "reset-confirm-content" },
            [
              _c("a-alert", {
                staticClass: "mb-3",
                attrs: { type: "warning", "show-icon": "" },
                scopedSlots: _vm._u([
                  {
                    key: "message",
                    fn: function () {
                      return [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("whatsappV3.warning"))),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "description",
                    fn: function () {
                      return [
                        _c(
                          "ul",
                          {
                            staticStyle: {
                              margin: "0",
                              "padding-left": "20px",
                            },
                          },
                          [
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.$t("whatsappV3.resetWarning1"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.$t("whatsappV3.resetWarning2"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.$t("whatsappV3.resetWarning3"))
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("whatsappV3.resetConfirmQuestion"))),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }